import React from 'react';
import { TableCell } from '@mui/material';
import { financialConditionGenerationStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

export const FinancialConditionTableCell: React.FC<React.PropsWithChildren> = ({ children }) => (
  <TableCell sx={financialConditionGenerationStyles.editableTableCell}>{children}</TableCell>
);
